import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem as MuiMenuItem, } from '@mui/material';
import { forwardRef } from 'react';
export const MenuItem = forwardRef(function MenuItem({ children, ...props }, ref) {
    return (_jsx(MuiMenuItem, { ref: ref, ...props, children: children }));
});
